export const ADD_LANGUAGE = 'ADD_LANGUAGE';
export const DELETE_LANGUAGE = 'DELETE_LANGUAGE';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_AVAILABLE_LANGUAGES = 'SET_AVAILABLE_LANGUAGES';
export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE';
export const OPEN_LANGUAGE_MODAL = 'OPEN_LANGUAGE_MODAL';
export const CLOSE_LANGUAGE_MODAL = 'CLOSE_LANGUAGE_MODAL';
